define('lib/Podio.Transport.Mentions',['require','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function getMentionsData(query, spaceId, callback) {
    var reqUrl  = routes.autocomplete_mentions_search_path();
    var req = transport.cachedRequest('get', 'json', reqUrl, {
      abortable: true,
      storeKey :'autcomplete_mentions',
      requestKey : 'query-' + query,
      requestData : {
        query: query,
        space_id: spaceId
      }
    });

    return req;
  }

  return {
    getMentionsData: getMentionsData
  };

});

